import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function CosmicLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="CosmicLogo">
      <path
        d="M8.17937 7.49817C8.58392 7.15587 8.95736 6.81357 9.36191 6.50238C9.05072 6.28455 8.77064 6.09784 8.49057 5.91113C8.14825 6.1912 7.80594 6.50238 7.46362 6.81357C7.80594 6.93804 8.05489 7.18699 8.17937 7.49817Z"
        fill="#29ABE2"
      />
      <path
        d="M7.18028 9.05427C7.91932 9.05622 8.51993 8.48658 8.52179 7.78194C8.52365 7.0773 7.92605 6.5045 7.18701 6.50255C6.44798 6.5006 5.84737 7.07024 5.84551 7.77488C5.84365 8.47952 6.44125 9.05232 7.18028 9.05427Z"
        fill="#29ABE2"
      />
      <path
        d="M8.39731 14.935C6.56126 15.9308 4.97417 16.1798 4.25842 15.4952C3.2626 14.5305 4.16506 12.0099 6.34343 9.45818C6.00111 9.36482 5.72104 9.11587 5.56544 8.80469C2.39125 12.3522 0.959755 15.9308 2.36013 17.2689C3.51155 18.3892 6.28119 17.6423 9.3309 15.6507C9.0197 15.4329 8.70851 15.184 8.39731 14.935Z"
        fill="#29ABE2"
      />
      <path
        d="M10.575 6.43999C10.6684 6.09769 10.9173 5.81762 11.2285 5.66203C7.5564 2.64354 3.82206 1.30545 2.42168 2.64354C1.27026 3.76381 2.01713 6.40888 4.10214 9.33401C4.35109 9.02282 4.60005 8.74276 4.84901 8.43157C3.82206 6.65782 3.54199 5.13302 4.25774 4.41729C5.28468 3.45262 7.89872 4.35506 10.575 6.43999Z"
        fill="#29ABE2"
      />
      <path
        d="M13.0651 7.31152C12.9406 7.62271 12.6606 7.87166 12.3494 7.99613C12.8162 8.46291 13.2518 8.89857 13.6253 9.36534C13.8431 9.08528 14.0609 8.80521 14.2165 8.52514C13.8742 8.1206 13.4697 7.71606 13.0651 7.31152Z"
        fill="#29ABE2"
      />
      <path
        d="M12.3184 8.55562C13.0652 8.55562 13.6565 7.99548 13.6565 7.27976C13.6565 6.56404 13.0652 6.00391 12.3184 6.00391C11.5715 6.00391 10.9802 6.56404 10.9802 7.27976C10.9802 7.96437 11.5715 8.55562 12.3184 8.55562Z"
        fill="#29ABE2"
      />
      <path
        d="M15.7727 4.44868C16.7685 5.41335 15.866 7.93394 13.6877 10.4857C14.03 10.579 14.3101 10.828 14.4657 11.1391C17.6087 7.59164 19.0402 3.9819 17.6398 2.64381C16.4884 1.55466 13.7188 2.30151 10.7002 4.29309C11.0114 4.51092 11.3226 4.75986 11.6338 5.00881C13.4698 4.01302 15.0569 3.76407 15.7727 4.44868Z"
        fill="#29ABE2"
      />
      <path
        d="M12.0694 12.2275C11.6026 12.6632 11.1047 13.0677 10.6379 13.4412C10.9491 13.659 11.2292 13.8457 11.5404 14.0324C11.9761 13.6901 12.3806 13.3167 12.8163 12.9121C12.474 12.7877 12.225 12.5387 12.0694 12.2275Z"
        fill="#29ABE2"
      />
      <path
        d="M12.8354 10.9065C12.0964 10.9045 11.4957 11.4741 11.4937 12.1787C11.4918 12.8833 12.0893 13.4562 12.8284 13.4582C13.5674 13.4603 14.1681 12.8907 14.17 12.1861C14.172 11.4814 13.5744 10.9086 12.8354 10.9065Z"
        fill="#29ABE2"
      />
      <path
        d="M7.68162 11.9786C7.21483 11.5118 6.77915 11.0762 6.40572 10.6094C6.18789 10.8894 5.97005 11.1695 5.81445 11.4496C6.18789 11.8541 6.56132 12.2586 6.96587 12.6632C7.09035 12.352 7.3393 12.1031 7.68162 11.9786Z"
        fill="#29ABE2"
      />
      <path
        d="M15.9282 10.6406C15.6793 10.9518 15.4303 11.2319 15.1814 11.5431C16.2083 13.3168 16.4884 14.8105 15.7415 15.5262C14.7146 16.4909 12.1005 15.5885 9.42426 13.5346C9.3309 13.8769 9.08195 14.157 8.77075 14.3126C12.474 17.3311 16.2083 18.7003 17.6087 17.3622C18.7601 16.2108 18.0132 13.5346 15.9282 10.6406Z"
        fill="#29ABE2"
      />
      <path
        d="M9.05658 12.6804C9.05842 11.9758 8.46082 11.403 7.72178 11.401C6.98275 11.3991 6.38215 11.9687 6.3803 12.6734C6.37845 13.378 6.97606 13.9508 7.71509 13.9527C8.45413 13.9547 9.05473 13.385 9.05658 12.6804Z"
        fill="#29ABE2"
      />
    </LogoSkeleton>
  )
}
